<template>
  <div class="project-documents-tab accordion" role="tablist">
    <AccessBlock :id="PROJECT_DOCUMENTS_BLOCK">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-documents
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-folder-open mr-2"></i>{{ $t('documents') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="project-documents" role="tabpanel" visible>
          <div class="accordion-content px-2 py-2">
            <ProjectDocuments
              v-if="documentsBlock"
              :blockId="PROJECT_DOCUMENTS_BLOCK"
              :project="documentsBlock"
            />
          </div>
        </b-collapse>
      </div>
    </AccessBlock>
  </div>
</template>

<script>
import AccessBlock from '@/components/Access/AccessBlock.vue';
import ProjectDocuments from '@/blocks/project/ProjectDocuments';
import { PROJECT_DOCUMENTS_BLOCK } from '@/navigation/accessNodes';

/** Number of the unsaved project (ProjectEdit `_new`); it has no blocks yet. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Tab Dokumente of the project detail (see feature page projekt-dokumente): one accordion section
 * "Dokumente" around the one block of the tab, open at the start. The section sits inside
 * `AccessBlock`, so it disappears without a level and its header stays usable for readers.
 */
export default {
  name: 'ProjectDocumentsTab',
  components: {
    AccessBlock,
    ProjectDocuments,
  },
  props: {
    project: { type: Object, required: true },
  },
  data() {
    return {
      PROJECT_DOCUMENTS_BLOCK,
    };
  },
  computed: {
    /**
     * Block data; the unsaved project goes to the block itself. The block reads `project.id` at
     * once, so it is not rendered without data.
     */
    documentsBlock() {
      if (this.project.number === NEW_PROJECT_NUMBER) {
        return this.project;
      }

      return this.project.blocks?.documents ?? null;
    },
  },
};
</script>
